import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n';
import { ThemeProvider } from './theme/ThemeProvider';
import './index.css';
import { App } from './App';

import { en } from './i18n/en.ts';
import { zh } from './i18n/zh.ts';

const translations = { en, zh };

const root = createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider>
    <I18nProvider translations={translations}>
      <App />
    </I18nProvider>
  </ThemeProvider>
);
